import CryptoJS from 'crypto-js';
import config from '../data/config';

const SECRET_KEY = config.CRYPTO_SECRET_KEY;

// Encrypt data
export const encryptData = (data: any): string => {
  if (!data) return '';
  const dataString = typeof data === 'string' ? data : JSON.stringify(data);
  return CryptoJS.AES.encrypt(dataString, SECRET_KEY).toString();
};

// Decrypt data
export const decryptData = (encryptedData: string): any => {
  if (!encryptedData) return null;
  
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    
    // Try to parse as JSON, return as string if not valid JSON
    try {
      return JSON.parse(decryptedString);
    } catch (e) {
      return decryptedString;
    }
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};